export default {"src":"/_next/static/media/safariscreen.abad3db5.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};